import React, { useEffect, useState } from "react";
import { currencyFormatter } from "@utils";
import { connect } from "react-redux";
import { defaultAction } from "@actions/defaultAction";
import { OPEN_PAYMENT_DETAILS_MODAL } from "@constants/actionTypes";
import styled from "@emotion/styled";
import classNames from "classnames";
import PaymentDetails from "@components/PaymentDetails";
import { IoIosArrowBack } from "react-icons/io";
import SmallSpinner from "@components/SmallSpinner";

const PopUpContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 109;
  overflow-y: scroll;
  background-color: rgba(31, 32, 33, 0.8);
`;

const Container = styled.div`
  width: 579px;
  height: auto;
  border-radius: 30px;
  background-color: #f8f8f8;
  margin: 0 auto;
  margin-top: 100px;
  position: relative;
  @media (max-height: 900px) {
    margin-top: 63px;
  }
  @media (max-height: 815px) {
    margin-top: 45px;
  }
  @media (max-height: 735px) {
    margin-top: 15px;
  }

  @media (max-width: 600px) {
    width: 100%;
  }
`;

const CloseDiv = styled.div`
  display: flex;
  justify-content: flex-end;
  color: #9b9b9b;
  align-self: flex-start;
  padding-top: 20px;
  padding-right: 26px;
  padding-left: 26px;

  @media (max-height: 600px) {
    padding-right: 20px;
    padding-top: 20px;
  }

  @media (max-width: 450px) {
    padding-right: 20px;
  }
`;

const CloseDivImage = styled.img`
  width: 17px;
`;

const CloseSpan = styled.span`
  cursor: pointer;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  margin: 0 auto;
  max-width: 490px;
  padding-bottom: ${props => props.paddingBottom};
  text-align: left;
  margin-top: -10px;
  position: relative;
  max-height: ${props => props.contentMaxHeight};
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 0px;
  }
  @media (max-height: 815px) {
    margin-top: -12px;
  }

  @media (max-width: 600px) {
    width: 87%;
  }
  @media (max-width: 415px) {
    margin-top: 10px;
  }
`;

const BottomContent = styled.div`
  padding-top: 32px;
  max-width: 464px;
  margin: 0 auto;
  padding-bottom: 47px;

  @media (max-width: 600px) {
    width: 87%;
  }
`;

const Bottom = styled.div`
  position: relative;
  box-shadow: 0 -8px 20px 0 rgba(38, 38, 38, 0.05);
  background-color: #ffffff;
  border-radius: 0px 0px 30px 30px;
`;

const Header = styled.div`
  font-size: 30px;
  font-weight: 500;
  line-height: 1.4;
  text-align: center;
  color: #1f2021;
  margin: 0 auto;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-height: 815px) {
    font-size: 28px;
  }

  @media (max-width: 475px) {
    font-size: 24px;
  }
  @media (max-width: 360px) {
    font-size: 25px;
    max-width: 217px;
  }
  @media (max-width: 325px) {
    font-size: 20px;
  }
`;

const BackArrow = styled(IoIosArrowBack)`
  color: rgba(119, 121, 132, 0.5);
  position: absolute;
  font-size: 30px;
  left: 0;
  cursor: pointer;

  @media (max-width: 375px) {
    font-size: 27px;
  }
  @media (max-width: 330px) {
    font-size: 24px;
  }
  @media (max-width: 300px) {
    font-size: 22px;
  }
`;

const PaymentGrid = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  color: #1f2021;
  border-bottom: ${props => props.borderBottom};
  padding: ${props => props.padding};
`;

const GridHeader = styled.div`
  font-size: 14px;
  color: #777984;
`;

const GridAmount = styled.div`
  font-weight: normal;
  color: #1f2021;
`;

const GridTotal = styled.div`
  font-weight: normal;
  color: #777984;
`;

const GridTotalValue = styled.div`
  font-weight: normal;
`;

const GridBottomValue = styled.div`
  font-size: 18px;
  font-weight: bold;
  text-align: right;
  color: #1f2021;
`;

const DollarSpan = styled.span`
  font-size: 16px;
  color: #777984;
`;

const BottomShadowBox = styled.div`
  height: 110px;
  background-image: linear-gradient(
    to bottom,
    rgba(248, 247, 248, 0),
    rgba(248, 247, 248, 0.5)
  );
  position: absolute;
  text-align: center;
  width: 100%;
  border-radius: 0px 0px 30px 0px;
  display: ${props => props.display};
  top: -110px;
  pointer-events: none;
`;

const ShadowBox = styled.div`
  height: 110px;
  top: 99px;
  transform: rotate(-180deg);
  background-image: linear-gradient(
    to bottom,
    rgba(248, 247, 248, 0),
    rgba(248, 247, 248, 0.5)
  );
  position: absolute;
  text-align: center;
  width: 100%;
  border-radius: 0px 0px 30px 0px;
  display: ${props => props.display};
`;

const DeductionComment = styled.div`
  font-size: 14px;
  color: #777984;
  margin-top: 15px;
`;

const PaymentDetailsModal = ({
  showPaymentDetailsModal,
  paymentsSell,
  hideModal,
  currentOrder
}) => {
  const [cardSelected, setCardSelected] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => (document.body.style.overflow = "initial");
  }, [showPaymentDetailsModal]);

  const closeModal = () => {
    hideModal();
  };

  const payment = paymentsSell.payment;
  const paymentCardsExist = payment && payment.cards && payment.cards.length;
  const paymentCards =
    payment.cards &&
    payment.cards.length &&
    payment.cards.reduce(
      (prevCard, currentCard) => prevCard + Number(currentCard.amount),
      0
    );
  const paymentDeductions =
    payment.deductions &&
    payment.deductions.length &&
    payment.deductions.reduce(
      (prevDed, currentDed) => prevDed + Number(currentDed.amount),
      0
    );
  const paymentAdjustments =
    payment.adjustments &&
    payment.adjustments.length &&
    payment.adjustments.reduce(
      (prevAdj, currentAdj) => prevAdj + Number(currentAdj.amount),
      0
    );
  const shippingReimbursements = payment.shippingReimbursements;

  let associatedCards = payment.cards || [];

  let numItems = 0;
  if (paymentDeductions) {
    numItems = numItems + 2;
  }
  if (paymentAdjustments) {
    numItems++;
  }
  if (shippingReimbursements) {
    numItems++;
  }
  const negate = numItems * 40;
  const contentMaxHeight = `${545 - negate}px`;

  return (
    <PopUpContainer className={classNames("animated", "fast", "fadeInUp")}>
      <Container onClick={e => e.stopPropagation()}>
        {loader && <SmallSpinner />}
        {cardSelected && (
          <ShadowBox
            display={associatedCards.length > 6 ? "inherit" : "none"}
          />
        )}
        <CloseDiv className="mar-t-10">
          <CloseSpan onClick={closeModal}>
            <CloseDivImage
              src="https://cdn.cardcash.com/website/ui/elements/close.svg"
              aria-hidden="true"
              alt="close button"
            />
          </CloseSpan>
        </CloseDiv>
        <Content
          paddingBottom={cardSelected ? "60px" : "38px"}
          contentMaxHeight={contentMaxHeight}
        >
          <Header>
            {cardSelected && (
              <BackArrow onClick={() => setCardSelected(false)} />
            )}
            <div>Payment Details</div>
          </Header>
          {!cardSelected ? (
            <>
              {currentOrder?.payments?.length && (
                <PaymentDetails
                  payments={currentOrder.payments || []}
                  setCardSelected={setCardSelected}
                  setLoader={setLoader}
                />
              )}
            </>
          ) : (
            <div>
              {paymentCardsExist && (
                <>
                  <PaymentGrid>
                    <GridHeader>Associated Card ID</GridHeader>
                    <GridHeader>Amount </GridHeader>
                  </PaymentGrid>
                  {associatedCards.map((card, index) => (
                    <PaymentGrid
                      key={index}
                      borderBottom={"1px solid rgba(119, 121, 132, 0.15)"}
                      padding={"20px 0px"}
                    >
                      <div>{card.id}</div>
                      <GridAmount>{currencyFormatter(card.amount)}</GridAmount>
                    </PaymentGrid>
                  ))}
                </>
              )}
            </div>
          )}
        </Content>
        {cardSelected && (
          <Bottom>
            <BottomShadowBox
              display={associatedCards.length > 6 ? "inherit" : "none"}
            />
            <BottomContent>
              {paymentCards && (
                <>
                  <PaymentGrid padding={"7px 0px"}>
                    <GridTotal>Order Value</GridTotal>
                    <GridTotalValue>
                      {currencyFormatter(paymentCards)}
                    </GridTotalValue>
                  </PaymentGrid>
                </>
              )}
              <div>
                {paymentDeductions && (
                  <PaymentGrid padding={"7px 0px"}>
                    <GridTotal>Deductions*</GridTotal>
                    <GridTotalValue>
                      {`(${currencyFormatter(paymentDeductions || 0)})`}
                    </GridTotalValue>
                  </PaymentGrid>
                )}
                {paymentAdjustments && (
                  <PaymentGrid padding={"7px 0px"}>
                    <GridTotal>Adjustments</GridTotal>
                    <GridTotalValue>
                      {Math.sign(paymentAdjustments) === -1
                        ? `(${currencyFormatter(Math.abs(paymentAdjustments))})`
                        : currencyFormatter(paymentAdjustments)}
                    </GridTotalValue>
                  </PaymentGrid>
                )}
                {shippingReimbursements && (
                  <PaymentGrid padding={"7px 0px"}>
                    <GridTotal>Reimbursements</GridTotal>
                    <GridTotalValue>
                      {currencyFormatter(shippingReimbursements)}
                    </GridTotalValue>
                  </PaymentGrid>
                )}

                <PaymentGrid padding={"7px 0px"}>
                  <GridTotal>Total Payout</GridTotal>
                  <GridBottomValue>
                    <DollarSpan>$</DollarSpan>
                    {currencyFormatter(payment.amount, "no-symbol")}
                  </GridBottomValue>
                </PaymentGrid>

                {paymentDeductions && (
                  <DeductionComment>
                    *Deductions are typically the result of a claim against a
                    card that you previously sold.
                  </DeductionComment>
                )}
              </div>
            </BottomContent>
          </Bottom>
        )}
      </Container>
    </PopUpContainer>
  );
};

export default connect(
  state => ({
    showPaymentDetailsModal: state.popupsActions.showPaymentDetailsModal,
    paymentsSell: state.paymentsSell,
    currentOrder: state.ordersSell.sellOrder
  }),
  dispatch => ({
    hideModal: () => dispatch(defaultAction(OPEN_PAYMENT_DETAILS_MODAL, false))
  })
)(PaymentDetailsModal);
